import type { UpdateBlockStateType } from '@unifyapps/carbon/no-code/components/BlockRenderer/types';
import type { CardBlockStateType } from '@unifyapps/defs/types/blocks';
import useEventCallback from '@unifyapps/hooks/useEventCallback';

export const useCollapsibleParams = ({
  blockState,
  updateBlockState,
}: {
  blockState: CardBlockStateType;
  updateBlockState: UpdateBlockStateType<CardBlockStateType>;
}) => {
  const isCollapsed = Boolean(blockState.content.collapsible?.enabled && blockState.isCollapsed);

  const setIsCollapsed = useEventCallback((collapsed: boolean) => {
    updateBlockState((draft) => {
      draft.isCollapsed = collapsed;
      if (!draft.appearance) {
        draft.appearance = { isCollapsed: blockState.appearance?.isCollapsed ?? false };
      }
      draft.appearance.isCollapsed = collapsed;
    });
  });

  return {
    collapsibleParams: {
      isCollapsed,
      setIsCollapsed,
      enabled: blockState.content.collapsible?.enabled ?? false,
      defaultExpanded: blockState.content.collapsible?.isInitiallyExpanded ?? true,
    },
  };
};
